import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type CryptoDepositAddressState = Record<
  string,
  Record<string, Record<string, CryptoDepositAddress>>
>;

export type CryptoDepositsState = {
  currencies: WalletCurrencyOption[];
  optionsByWallet: Record<string, WalletCryptoDepositOptions>;
  addressesByWallet: CryptoDepositAddressState;
};

export const cryptoDepositsInitialState: CryptoDepositsState = {
  currencies: [],
  optionsByWallet: {},
  addressesByWallet: {},
};

const slice = createSlice({
  name: 'cryptoDeposits',
  initialState: cryptoDepositsInitialState,
  reducers: {
    resetCryptoDepositsAction: () => cryptoDepositsInitialState,
    setCryptoDepositCurrenciesAction(
      state,
      { payload }: PayloadAction<WalletCurrencyOption[]>,
    ) {
      state.currencies = payload;
    },
    setCryptoDepositOptionsAction(
      state,
      { payload }: PayloadAction<WalletCryptoDepositOptions>,
    ) {
      state.optionsByWallet[payload.walletId] = payload;
    },
    setCryptoDepositAddressesAction(
      state,
      {
        payload,
      }: PayloadAction<{
        walletId: string;
        currency: string;
        addresses: CryptoDepositAddress[];
      }>,
    ) {
      const walletAddresses = state.addressesByWallet[payload.walletId] ?? {};
      const currencyAddresses = walletAddresses[payload.currency] ?? {};

      payload.addresses.forEach((item) => {
        currencyAddresses[item.chainCode] = item;
      });

      walletAddresses[payload.currency] = currencyAddresses;
      state.addressesByWallet[payload.walletId] = walletAddresses;
    },
  },
});

export const {
  resetCryptoDepositsAction,
  setCryptoDepositCurrenciesAction,
  setCryptoDepositOptionsAction,
  setCryptoDepositAddressesAction,
} = slice.actions;

export default slice.reducer;
